import { getState } from '../state/store';
import Config from './config';

const HTTP_CODES = {
    SERVER_ERROR: 500,
    FORBIDDEN: 403
};

const responseHandler = async (response: any, onFail?: () => {}) => {
    if (response.status === HTTP_CODES.SERVER_ERROR) {
        if (onFail) return onFail();
    }

    if (response.status === HTTP_CODES.FORBIDDEN) {
        window.location.replace(Config.URL_COACHAPP);
        return;
    }

    let returnValue;
    try {
        returnValue = await response.text();
        returnValue = JSON.parse(returnValue);
    } catch (e) {
        returnValue = response;
    }

    if (
        returnValue &&
        typeof returnValue === 'object' &&
        !Array.isArray(returnValue) &&
        returnValue.status === undefined &&
        !response.ok
    ) {
        returnValue.status = response.status;
    }

    return returnValue;
};

const hasSessionToken = (token: string | null | undefined) =>
    Boolean(token && token !== 'null' && token !== 'undefined');

export async function authenticatedFetch(
    url: string,
    options: any = { method: 'GET' },
    onFail?: () => {},
    sessionToken?: string | null
) {
    const resolvedSessionToken = sessionToken ?? getState().authentication.token;

    const authenticatedOptions = { ...options };

    if (!authenticatedOptions.headers) {
        authenticatedOptions.headers = {};
    }

    authenticatedOptions.headers['Api-Token'] = 'DISABLED';
    if (hasSessionToken(resolvedSessionToken)) {
        authenticatedOptions.headers['Session-Token'] = resolvedSessionToken;
    }
    authenticatedOptions.credentials = 'include';

    if (options.method !== 'GET' && authenticatedOptions.headers['Content-Type'] === undefined) {
        authenticatedOptions.headers['Content-Type'] = 'application/json';
    }

    let response;
    try {
        response = await fetch(urlFormatter(url), authenticatedOptions);
    } catch (error) {
        if (onFail) return onFail();
        return;
    }

    return responseHandler(response, onFail);
}

export async function unauthenticatedFetch(url: string, options: any = { method: 'GET' }) {
    const authenticatedOptions = { ...options };

    if (!authenticatedOptions.headers) {
        authenticatedOptions.headers = {};
    }

    if (options.method !== 'GET' && authenticatedOptions.headers['Content-Type'] === undefined) {
        authenticatedOptions.headers['Content-Type'] = 'application/json';
    }

    const response = await fetch(urlFormatter(url), authenticatedOptions);

    return responseHandler(response);
}

export async function downloadFile(url: string, options: any = { method: 'GET' }) {
    const sessionToken = getState().authentication.token;

    const authenticatedOptions = { ...options };

    if (!authenticatedOptions.headers) {
        authenticatedOptions.headers = {};
    }

    authenticatedOptions.headers['Api-Token'] = 'DISABLED';
    if (hasSessionToken(sessionToken)) {
        authenticatedOptions.headers['Session-Token'] = sessionToken;
    }
    authenticatedOptions.credentials = 'include';

    const response = await fetch(urlFormatter(url), authenticatedOptions);

    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    try {
        const blob = await response.blob();
        return { data: blob, status: 200, error: null, message: null };
    } catch (error) {
        console.error('downloadFile error:', error);
        throw error;
    }
}

export const urlFormatter = (path: string) => {
    if (path.indexOf('http://') === 0 || path.indexOf('https://') === 0) {
        return path;
    }
    return `${Config.API}${path}`;
};
